import Message from "./messages"
const messageRoutes = [
    {
        path: '/core/messages',
        element: <Message />
    }
]
export default messageRoutes